import { giphyDarkGrey, giphyIndigo } from '@giphy/js-brand'
import React, { useContext, useState } from 'react'
import CSRFToken from 'shared/components/form/csrftoken-hoc'
import Fields, { FIELDS } from 'shared/components/form/fields'
import { Content, CTAButton as BrandCTAButton, FormContainer, Title } from 'shared/components/form/form-components'
import styled from 'styled-components'
import { resetPassword } from "../../../shared/api"
import { FlashMessageContext } from "../../../shared/components/flash-message/flash-message"

const CTAButton = styled(BrandCTAButton)`
    width: 100%;
`

const PasswordResetForm = ({ csrftoken }) => {
    const [submitEnabled, setSubmitEnabled] = useState<boolean>(false)

    const { showMessage } = useContext((FlashMessageContext))

    const handleSubmit = async (event) => {
        event.preventDefault()

        const email = event.target[FIELDS.email].value

        try {
            await resetPassword({ email })
            showMessage({
                messageType: 'success',
                message: 'Check your email for a link to reset your password. If it doesn\'t appear within a few minutes, check your spam folder.',
                icon: '✉️',
                title: 'Email Sent!',
            })
        } catch (error) {
            showMessage({ messageType: 'failure' })
        }
    }

    return (
        <FormContainer>
            <form onSubmit={handleSubmit}>
                {csrftoken && <input type="hidden" name="csrfmiddlewaretoken" value={csrftoken} />}
                <Content>
                    <Title>
                        Reset <br />
                        Password
                    </Title>
                    <Fields onValidChange={setSubmitEnabled} showFields={[FIELDS.email]} />
                    <CTAButton color={submitEnabled ? giphyIndigo : giphyDarkGrey} disabled={!submitEnabled}>
                        Send Email
                    </CTAButton>
                </Content>
            </form>
        </FormContainer>
    )
}

export default CSRFToken(PasswordResetForm)
